import React from 'react';
import { Link } from 'react-router-dom';
import UserMenu from './UserMenu';
import Footer from './Footer';





export default function Container({ children }) {
  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 flex flex-col max-w-full overflow-x-hidden">

      {/* FIXED HEADER – always at top */}
      <header className="fixed inset-x-0 top-0 z-40 bg-slate-950 border-b border-slate-800 shadow-sm shadow-emerald-500/10">
        <div className="mx-auto max-w-7xl px-4 py-3 flex items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2">
            <img
              src="/kepithor_logo.png"
              alt="Kepithor logo"
              className="w-24 -mr-4"
            />
          </Link>

          <nav className="text-button">
            <UserMenu />
          </nav>
        </div>
      </header>

         {/* FIXED SIDE ADS – only on very wide screens (2xl+) */}
      <div className="hidden 2xl:block fixed inset-y-0 left-1/2 -translate-x-1/2 z-30 pointer-events-none">
        {/* 1600px rail: 160 (left ad) + 1240 (content) + 160 (right ad) */}
        <div className="w-[1600px] h-full flex items-start justify-between pt-24">
          {/* LEFT 160x600 */}
          <div className="pointer-events-auto w-[160px] h-[600px] bg-slate-900 rounded-2xl border border-slate-800 flex items-center justify-center">
           <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1487974375505356"
                crossorigin="anonymous"></script>
            <ins class="adsbygoogle"
                style={{display:"block"}}
                data-ad-client="ca-pub-1487974375505356"
                data-ad-slot="3227681563"
                data-ad-format="auto"
                data-full-width-responsive="true"></ins>
            <script>
                (adsbygoogle = window.adsbygoogle || []).push({});
            </script>
          </div>

          {/* RIGHT 160x600 */}
          <div className="pointer-events-auto w-[160px] h-[600px] bg-slate-900 rounded-2xl border border-slate-800 flex items-center justify-center">
            <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1487974375505356"
                crossorigin="anonymous"></script>
            <ins class="adsbygoogle"
                style={{display:"block"}}
                data-ad-client="ca-pub-1487974375505356"
                data-ad-slot="4381707483"
                data-ad-format="auto"
                data-full-width-responsive="true"></ins>
            <script>
                (adsbygoogle = window.adsbygoogle || []).push({});
            </script>
          </div>
        </div>
      </div>

      {/* MAIN CONTENT – centered, fits between ads on big screens */}
      <main className="w-full flex-1 pt-20 pb-24 px-4">
        {/* 🔹 slightly narrowed from 1280 → 1240 to avoid overlap */}
        <div className="mx-auto w-full max-w-[1240px]">
          {children}
        </div>
      </main>

      <Footer />
    </div>
  );
}
